// src/redux/bankaccountSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_bankaccount,
  add_bankaccount,
  update_bankaccount,
  delete_bankaccount,
  get_bankaccount_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  bankaccount: [],
  bankaccountlist:[],
  bankaccountfilterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:"",

  },
};

// Async Thunks for API Calls
export const fetchbankaccountlist = createAsyncThunk(
    'bankaccount/fetchbankaccountlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_bankaccount_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchbankaccount = createAsyncThunk(
  "bankaccount/fetchbankaccount",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_bankaccount(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createbankaccount = createAsyncThunk(
  "bankaccount/createbankaccount",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_bankaccount(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatebankaccount = createAsyncThunk(
  "bankaccount/updatebankaccount",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_bankaccount(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletebankaccount = createAsyncThunk(
  "bankaccount/deletebankaccount",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_bankaccount({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// bankaccount Slice
const bankaccountSlice = createSlice({
  name: 'bankaccounts',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, title,bank_name,account_no,ifsc,balance} = action.payload;
      state.formData = { id, title,bank_name,account_no,ifsc,balance};
    },
    resetFormData(state) {
      state.formData = {
       title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:0,
      };
    },
    setbankaccount(state, action) {
      state.bankaccount = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchbankaccountlist.fulfilled, (state, action) => {
        state.bankaccountlist = action.payload.data;
      })
      .addCase(fetchbankaccountlist.rejected, (state, action) => {
        state.bankaccountlist = [];
      })
     
       // Fetch bankaccount
       .addCase(fetchbankaccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchbankaccount.fulfilled, (state, action) => {
        state.loading = false;
        state.bankaccount = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchbankaccount.rejected, (state, action) => {
        state.loading = false;
        state.bankaccount = [];
        state.error = action.payload;
      })

      // Add bankaccount
      .addCase(createbankaccount.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createbankaccount.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createbankaccount.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update bankaccount
      .addCase(updatebankaccount.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatebankaccount.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatebankaccount.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete bankaccount
      .addCase(deletebankaccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletebankaccount.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletebankaccount.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setbankaccount,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = bankaccountSlice.actions;
export default bankaccountSlice.reducer;
